var _path;
var _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var SvgConfirm = function SvgConfirm(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 492 492",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M484.13 104.48L468 88.36A26.7 26.7 0 00449 80.51a26.7 26.7 0 00-19.03 7.85L203.51 314.81 62.02 173.32A26.73 26.73 0 0043 165.47c-7.2 0-13.96 2.8-19.03 7.85L7.85 189.43A26.75 26.75 0 000 208.47c0 7.2 2.78 13.96 7.85 19.03L167.6 387.23c.2.3.43.58.7.84l16.11 15.85c5.07 5.05 11.82 7.57 19.09 7.57h.08c7.21 0 13.97-2.52 19.02-7.57l16.13-15.99c.26-.26.48-.47.61-.68l244.78-244.76a26.87 26.87 0 000-38.01z"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfirm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confirm.0a5d2007.svg";
export { ForwardRef as ReactComponent };